import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { DisclosureBanner } from "../components/DisclosureBanner";
import { LegalLayout } from "./LegalLayout";
import { Mail } from "lucide-react";
import { useLegalSEO } from "../lib/useLegalSEO";

const Contact = () => {
    useLegalSEO({
        title: "Contact | Better Rest Report",
        description:
            "Get in touch with the Better Rest Report — editorial questions, reader inquiries, and partnerships.",
        path: "/contact",
    });
    return (
    <div className="App">
        <DisclosureBanner variant="top" />
        <Header />
        <LegalLayout
            kicker="Get in touch"
            title="Contact"
            updated=""
            testId="page-contact"
        >
            <p>
                Thank you for visiting the Better Rest Report. If you have a
                question about our editorial coverage, an inquiry from a
                reader, or a press request, we'd love to hear from you.
            </p>

            <h2>Editorial & Reader Inquiries</h2>
            <p>
                For editorial questions, comments on a published review, or
                suggestions for future coverage, please email us at the
                address below. We try to respond within 3–5 business days.
            </p>

            <div
                data-testid="contact-email-card"
                className="my-8 rounded-2xl p-7 border border-[color:var(--brr-border)] bg-white flex items-center gap-5"
            >
                <div
                    className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ background: "var(--brr-blue-soft)" }}
                >
                    <Mail
                        size={20}
                        strokeWidth={1.5}
                        style={{ color: "var(--brr-blue-hover)" }}
                    />
                </div>
                <div>
                    <p className="text-[11px] tracking-[0.22em] uppercase opacity-60 mb-1">
                        Email
                    </p>
                    <a
                        href="mailto:hello@sleepcomfortreport.com"
                        data-testid="contact-email-link"
                        className="font-serif-display text-xl"
                        style={{ color: "var(--brr-ink)" }}
                    >
                        hello@sleepcomfortreport.com
                    </a>
                </div>
            </div>

            <h2>Affiliate & Business</h2>
            <p>
                For partnership and advertising inquiries, please use the
                same email above with the subject line "Partnership."
                Editorial integrity is independent of any affiliate or
                advertising relationship.
            </p>

            <h2>Mailing Address</h2>
            <p>
                Better Rest Report
                <br />
                c/o SleepComfortReport.com
                <br />
                United States
            </p>

            <p>
                For details about our affiliate relationships, please read
                our <a href="/disclosure">Affiliate Disclosure</a>.
            </p>
        </LegalLayout>
        <Footer />
    </div>
    );
};

export default Contact;
